import { render, staticRenderFns } from "./ManufactureListOld.vue?vue&type=template&id=34609269&scoped=true"
import script from "./ManufactureListOld.vue?vue&type=script&lang=js"
export * from "./ManufactureListOld.vue?vue&type=script&lang=js"
import style0 from "./ManufactureListOld.vue?vue&type=style&index=0&id=34609269&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34609269",
  null
  
)

export default component.exports